'use strict';

angular.module('user')
    .component('logoutButton', {
        templateUrl: 'modules/user/components/logout-button/template.html',
        controller: 'LogoutButtonController',
    });
